// extracted by mini-css-extract-plugin
export default {"flexWrapper":"SignUpModal_flexWrapper__FY3Sg","btn":"SignUpModal_btn__rLaCP","error":"SignUpModal_error__e97tD","hide":"SignUpModal_hide__hPplz"};